import axios from "axios";
import { clearAllAuthData } from "./authStorage";

// Эндпоинты, где 401 — это НОРМА (проверка сессии при загрузке,
// попытки логина и т.п.). На них редиректить нельзя.
const SKIP_REDIRECT = [
    "/auth/master-session",
    "/auth/user-session",
    "/auth/master-login",
    "/auth/user-login",
    "/auth/master-register",
    "/auth/user-register",
    "/auth/switch-to-client",
    "/auth/switch-to-master",
    "/auth/client-handoff",
    "/auth/client-handoff/exchange",
    "/auth/logout",
];

let redirecting = false; // защита от гонки множества 401 подряд

const currentLang = () => {
    // берём язык из URL (/he/..., /ru/...), иначе fallback
    const seg = window.location.pathname.split("/").filter(Boolean)[0];
    if (seg && seg.length === 2) return seg;
    return (localStorage.getItem("i18nextLng") || "en").slice(0, 2);
};

const goToLogin = () => {
    if (redirecting) return;
    redirecting = true;

    // 1. чистим localStorage (токены/uid)
    clearAllAuthData();
    // 2. чистим кэш аккаунтов в sessionStorage
    try {
        sessionStorage.removeItem("user_account");
        sessionStorage.removeItem("master_account");
    } catch { }

    // 3. жёсткий редирект — сбрасывает и Redux, и любое зависшее состояние
    const lang = currentLang();
    window.location.assign(`/${lang}/login`);
};

// Вешаем перехватчик на переданный экземпляр axios
export const attachAuthGuard = (instance) => {
    instance.interceptors.response.use(
        (res) => res,
        (error) => {
            const status = error?.response?.status;
            const url = error?.config?.url || "";

            const isSkipped = SKIP_REDIRECT.some((p) => url.includes(p));
            const onLoginPage = window.location.pathname.includes("/login");

            if (status === 401 && !isSkipped && !onLoginPage) {
                goToLogin();
            }
            return Promise.reject(error);
        }
    );
};

// Глобальный axios (все прямые вызовы axios.get/post из слайсов)
attachAuthGuard(axios);